import { z } from "zod";
export var DmaCalculationFailure;
(function (DmaCalculationFailure) {
    DmaCalculationFailure["Internal"] = "Internal";
    DmaCalculationFailure["Calculation"] = "Calculation";
})(DmaCalculationFailure || (DmaCalculationFailure = {}));
export const dmaCalculationFailureDtoSchema = z.object({
    kind: z.nativeEnum(DmaCalculationFailure),
    message: z.string(),
});
